module.exports = __webpack_public_path__ + "./docs/img/debugger.0bbe4ccb40fa44ad718901e11e297c13.svg";